// src/context/NewPartRequestContext.js
import { createContext, useContext, useState } from "react";

const NewPartRequestContext = createContext();

export const NewPartRequestProvider = ({ children }) => {
  const [shouldReload, setShouldReload] = useState(false);

  const notifySaved = () => setShouldReload(true);
  const clearNotification = () => setShouldReload(false);

  return (
    <NewPartRequestContext.Provider value={{ shouldReload, notifySaved, clearNotification }}>
      {children}
    </NewPartRequestContext.Provider>
  );
};

export const useNewPartRequestContext = () => useContext(NewPartRequestContext);
